import React from 'react';

const ROWS = 12;
const COLS = 140;

function SearchLightHeader() {
  const getBarStyle = (rowIndex, colIndex) => {
    // 从中间向两边扩散：只按到中心列的距离，同一列同时亮，形成竖直亮带向左右扩散
    const centerCol = (COLS - 1) / 2;
    const distFromCenter = Math.abs(colIndex - centerCol);
    const delay = distFromCenter * 0.032 - 1.2;
    const duration = 2.5;
    return {
      animationDelay: `${delay.toFixed(2)}s`,
      animationDuration: `${duration}s`,
    };
  };

  return (
    <header className="SearchLightHeader">
      {/* 扫描线 */}

      {/* 底部反射光 */}
      <div className="SearchLightHeader__floor-glow" />

      {/* 光条 - 从背景中间向两侧散开逐渐消失 */}
      <div className="SearchLightHeader__light-bars">
        {Array.from({ length: ROWS }).map((_, rowIndex) => (
          <div key={rowIndex} className="SearchLightHeader__light-bars-row">
            {Array.from({ length: COLS }).map((_, colIndex) => (
              <div
                key={colIndex}
                className="SearchLightHeader__bar"
                style={getBarStyle(rowIndex, colIndex)}
              />
            ))}
          </div>
        ))}
      </div>


      {/* 中央内容 */}
      <div className="SearchLightHeader__content">
        <h1 className="SearchLightHeader__title">Project Searchlight</h1>
        <div className="SearchLightHeader__cta-wrapper">
          <button type="button" className="SearchLightHeader__cta">
            <svg className="SearchLightHeader__bulb-icon" viewBox="0 0 24 24" aria-hidden>
              <path d="M12 2C7.58 2 4 5.58 4 10c0 2.03.76 3.87 2 5.28V17c0 .55.45 1 1 1h1v1c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-1h1c.55 0 1-.45 1-1v-1.72c1.24-1.41 2-3.25 2-5.28 0-4.42-3.58-8-8-8zm0 14c-1.1 0-2-.9-2-2h4c0 1.1-.9 2-2 2zm4-4H8v-1h8v1zm0-3H8V8h8v1z" />
            </svg>
            <span className="SearchLightHeader__cta-text">What is Searchlight?</span>
          </button>
          <div className="SearchLightHeader__tooltip">
            Searchlight is our exclusive program for creators. Allowing you to find new games and
            help them get fully developed. Give them a shout if your interested.
          </div>
        </div>
      </div>
    </header>
  );
}

export default SearchLightHeader;

